import TopBar from "@/pages/home/components/TopBar";
import SiteHeader from "@/pages/home/components/SiteHeader";
import Hero from "@/pages/home/components/Hero";
import CategoryIndex from "@/pages/home/components/CategoryIndex";
import FeaturedGrid from "@/pages/home/components/FeaturedGrid";
import HotList from "@/pages/home/components/HotList";
import Collections from "@/pages/home/components/Collections";
import FindPath from "@/pages/home/components/FindPath";
import Faq from "@/pages/home/components/Faq";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <TopBar />
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <CategoryIndex />
        <FeaturedGrid />
        <HotList />
        <Collections />
        <FindPath />
        <Faq />
      </main>
      <SiteFooter />
    </div>
  );
}